import axios from "axios";
import { PAYMENT_CREATE, PAYMENT_CREATE_COURSE, PAYMENT_FAILURE, PAYMENT_SUCCESS } from "../constants/actionTypes";
import { PAYMENT_CREATE_API, PAYMENT_FAILURE_API, PAYMENT_SUCCESS_API } from "../constants/apis";
import { errorMessageFromResponse } from "../constants/commonFunctions";
import { pushNotification } from "./pushNotification";
import { store } from "../store";
import { handleErrorMessage } from "./classes";

const CURRENCY = "INR"
const SERVICE = "Zoom"

export const createPayment = () => {
    const token = store.getState()?.profile?.user?.token;
    return async (dispatch) => {
      await axios({
        method: "post",
        url: PAYMENT_CREATE_API,
        data: {
            currency: CURRENCY,
            service: SERVICE,
            // amount: zoomSubscriptionPackages.subscriptionAmount
        },
        headers: {
          Authorization: `Token ${token}`,
        },
      })
        .then((response) => {
            dispatch({ type: PAYMENT_CREATE, payload: response.data.data });
        })
        .catch(async (error) => {
          dispatch(handleErrorMessage(errorMessageFromResponse(error)));
          return error;
        });
    };
  };

  export const successPayment = (data) => {
    const token = store.getState()?.profile?.user?.token;
    return async (dispatch) => {
      await axios({
        method: "put",
        url: PAYMENT_SUCCESS_API,
        data,
        headers: {
          Authorization: `Token ${token}`,
        },
      })
        .then(async(response) => {
                    await pushNotification(
              'Payment Successfull',
              `You payment has been done successfully .`,
            );

            dispatch({ type: PAYMENT_SUCCESS, payload: response.data.data });
            // dispatch(handleSuccessMessage(response.data.data.message))            
        })
        .catch(async (error) => {
          dispatch(handleErrorMessage(errorMessageFromResponse(error)));
          return error;
        });
    };
  }
  export const failurePayment = (data) => {
    const token = store.getState()?.profile?.user?.token;
    return async (dispatch) => {
      await axios({
        method: "put",
        url: PAYMENT_FAILURE_API,
        data,
        headers: {
          Authorization: `Token ${token}`,
        },
      })
        .then(async(response) => {
          await pushNotification(
              'Payment Rejected',
              `You payment has been failed, Please try again.`,
            );
            dispatch({ type: PAYMENT_FAILURE, payload: response.data.data });
            // dispatch(handleSuccessMessage(response.data.data.message))            

        })
        .catch(async (error) => {
          // dispatch(handleErrorMessage(errorMessageFromResponse(error)));
          return error;
        });
    };
  }


  // create payment method for courseMonetisation

  
export const createPaymentCourse = (id,amount) => {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    await axios({
      method: "post",
      url: PAYMENT_CREATE_API,
      data: {
          currency: "USD",
          product_id:id,
          service: "course",
          amount: amount
      },
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then(async(response) => {
 await pushNotification(
              'Course Enrollment',
              `You have successfully enrolled in this course.`,
            );
                    dispatch({ type: PAYMENT_CREATE_COURSE, payload: response.data.data });
          

      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};


